import { jsx } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import Dropzone from "react-dropzone";
import ToolbarItem from "./ToolbarItem";
import { compose, withHandlers } from "recompose";
import { importSequenceFromFile, connectToEditor } from "../withEditorProps";
export default compose(
  connectToEditor(),
  withHandlers({ importSequenceFromFile })
)(({ toolbarItemProps, importSequenceFromFile: importSequenceFromFile2 }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "veImportTool", icon: "export" }),
        IconWrapper: Dropzone,
        IconWrapperProps: {
          multiple: false,
          style: {},
          onDrop: (files) => importSequenceFromFile2(files[0])
        },
        tooltip: "Click or drag to import and view files (.fasta .gb .dna)",
        ...toolbarItemProps
      }
    }
  );
});
